import { z } from 'zod';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

const zodDecimalSchema = z.union([z.number(), z.string()]).nullish();

const zodChargeOrAllowancePatchSchema = z.object({
  absolutePerItem: zodDecimalSchema,
  absoluteTotal: zodDecimalSchema,
  basisAmount: zodDecimalSchema,
  name: z.string().trim().nullish(),
  percentage: zodDecimalSchema,
});

export const zodUpdateLineItemPayloadSchema = z.object({
  accountingReferenceIds: z.array(z.uuid()).nullish(),
  additionalQuantity: zodDecimalSchema,
  additionalUnitType: z.string().trim().nullish(),
  allowances: z.array(zodChargeOrAllowancePatchSchema).nullish(),
  applicableTax: z.string().trim().nullish(),
  buyerOrder: z.string().trim().nullish(),
  charges: z.array(zodChargeOrAllowancePatchSchema).nullish(),
  comment: z.string().trim().nullish(),
  contractId: z.uuid().nullish(),
  costCenter: z.string().trim().nullish(),
  currency: z.string().trim().nullish(),
  description: z.string().trim().nullish(),
  grossPrice: zodDecimalSchema,
  name: z.string().trim().nullish(),
  netPricePerQuantity: zodDecimalSchema,
  note: z.string().trim().nullish(),
  position: z.number().int().nullish(),
  quantity: zodDecimalSchema,
  sellerAssignedId: z.string().trim().nullish(),
  sellerOrder: z.string().trim().nullish(),
  taxPercent: zodDecimalSchema,
  total: zodDecimalSchema,
  unit: z.string().trim().nullish(),
  unitPrice: zodDecimalSchema,
});

export const zodUpdateLineItemResponseSchema = zodInvoiceDetailSchema;
